import React, { useEffect, useState } from "react";
import { MessageCircle, Phone, ChevronUp } from "lucide-react";
import { DOCTOR } from "@/data/static";

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div className="fixed right-4 md:right-6 bottom-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${DOCTOR.whatsapp}?text=Hi%20Doctor%2C%20I%20would%20like%20to%20book%20an%20appointment`}
        target="_blank" rel="noreferrer"
        className="h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={`tel:${DOCTOR.phoneRaw}`}
        className="h-14 w-14 rounded-full bg-primary text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform"
        data-testid="floating-call"
        aria-label="Call"
      >
        <Phone className="w-6 h-6" />
      </a>
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="h-12 w-12 rounded-full bg-white text-primary border border-slate-200 flex items-center justify-center shadow-md hover:scale-110 transition-transform"
          data-testid="back-to-top"
          aria-label="Back to top"
        >
          <ChevronUp className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
